import React, { useState, useEffect } from 'react';
import { Chart } from 'primereact/chart';
import { t } from '../../content';
import { useLocale } from '../../locale';
import { localizeMetricLabels } from '../Analytics/localizeAnalytics';

const TeamSimulatorVerticalCharts = ({labels, isGroupAFocused, groupAData, groupBData, chartTitle, leftChartLabel = t('simulator.groupA'), rightChartLabel = t('simulator.groupB')}) => {
    const { locale } = useLocale();
    const [leftChartData, setLeftChartData] = useState({});
    const [rightChartData, setRightChartData] = useState({});
    const [leftChartOptions, setLeftChartOptions] = useState({});
    const [rightChartOptions, setRightChartOptions] = useState({});

    useEffect(() => {
        const localizedLabels = localizeMetricLabels(labels || []);
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        const leftChartDataSettings = {
            labels: localizedLabels,
            datasets: [
                {
                    label: leftChartLabel,
                    categoryPercentage: 1.0,
                    barPercentage: 1.0,
                    barThickness: 15,
                    backgroundColor: (context) => {
                        if (isGroupAFocused) {
                            return context.dataIndex <= 4 ? '#00B0A0' : '#59287A';
                        } else {
                            return '#9e9d9dff';
                        }
                    },
                    borderColor: 'rgb(53, 196, 220)',
                    data: groupAData
                }
            ]
        };



        const leftChartOptionSettings = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            indexAxis: 'y',
            plugins: {
                legend: {
                    display: false,
                },
                title: {
                    display: true,
                    text: leftChartLabel,
                    fontColor: textColor
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                        font: {
                            weight: 500
                        },
                        stepSize: 1 // You can adjust this value based on your data range and requirements
                    },
                    grid: {
                        display: true,
                        drawBorder: true
                    },
                    reverse: true,
                    beginAtZero: true,
                    min: 0,
                    max: 9,
                },
                y: {
                    ticks: {
                        display: false,
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                }
            }
        };

        const rightChartDataSettings = {
            labels: localizedLabels,
            datasets: [
                {
                    label: rightChartLabel,
                    categoryPercentage: 1.0,
                    barPercentage: 1.0,
                    barThickness: 15,
                    backgroundColor: (context) => {
                        if (!isGroupAFocused) {
                            return context.dataIndex <= 4 ? '#00B0A0' : '#59287A';
                        } else {
                            return '#9e9d9dff';
                        }
                    },
                    borderColor: 'rgb(53, 196, 220)',
                    data: groupBData
                }
            ]
        };

        const rightChartOptionSettings = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            indexAxis: 'y',
            plugins: {
                legend: {
                    display : false
                },
                title: {
                    display: true,
                    text: rightChartLabel,
                    fontColor: textColor
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                        font: {
                            weight: 500
                        },
                        stepSize: 1 // You can adjust this value based on your data range and requirements
                    },
                    grid: {
                        display: true,
                        drawBorder: true
                    },
                    beginAtZero: true,
                    min: 0,
                    max: 9,
                },
                y: {
                    ticks: {
                        color: textColorSecondary,
                        crossAlign: "center"
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    },
                }
            }
        };
        setLeftChartData(leftChartDataSettings);
        setLeftChartOptions(leftChartOptionSettings);

        setRightChartData(rightChartDataSettings);
        setRightChartOptions(rightChartOptionSettings);
    }, [labels, locale, isGroupAFocused, groupAData, groupBData, rightChartLabel, leftChartLabel]);

    return (
        <div style={{width:"100%"}}>
        <div className="title">
            <p className='l bold'>
                {chartTitle}
            </p>
        </div>
        <div className='legends' style={{ display: 'flex', gap: '30px', justifyContent: 'center' }}>
            <span className='legend-item' style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span className='legend-color-box' style={{
                    width: '12px',
                    height: '12px',
                    backgroundColor: '#00B0A0',
                    display: 'inline-block'
                }}></span>
                <span className='legend-label'>{t('analytics.highestMetrics')}</span>
            </span>
            <span className='legend-item' style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span className='legend-color-box' style={{
                    width: '12px',
                    height: '12px',
                    backgroundColor: '#59287A',
                    display: 'inline-block'
                }}></span>
                <span className='legend-label'>{t('analytics.lowestMetrics')}</span>
            </span>
        </div>

        <div className='vertical-chart-div'>
            <div style={{ display: 'flex' ,height: "300px", width: "100%"}}>
                <div style={{ flex: '30%', padding: '10px 0 10px 10px' }}>
                    <Chart height='300px' width='100%' type="bar" data={leftChartData} options={leftChartOptions} />
                </div>
                <div style={{ flex: '35%', padding: '10px 0px 10px 0px' }}>
                    <Chart height='300px' width='100%' type="bar" data={rightChartData} options={rightChartOptions} />
                </div>
            </div>
        </div>
        </div>
    )
}
export default TeamSimulatorVerticalCharts;
